import client from "src/api/client";
import type { GetDownloadDocumentResponse } from "src/api/interfaces/download_document";
import type { InboundDocument } from "src/api/interfaces/inbound_document";

const handleGetDownloadDocumentUrl = async (
  inboundDocument: InboundDocument,
  attachment?: string
): Promise<GetDownloadDocumentResponse> => {
  return client.getDownloadDocumentUrl({
    countryCode: inboundDocument.countryCode,
    documentId: inboundDocument.documentId,
    documentType: inboundDocument.documentType,
    attachment,
  });
};

export default handleGetDownloadDocumentUrl;
